import { PROSPECT_STATUSES, type Prospect, type ProspectStatus } from "./api-types";

export const STATUS_LABEL: Record<ProspectStatus, string> = {
  new: "New",
  to_call: "To call",
  called: "Called",
  interested: "Interested",
  demo: "Demo",
  customer: "Customer",
  not_interested: "Not interested",
};

export const STATUS_OPTIONS = PROSPECT_STATUSES.map((value) => ({ value, label: STATUS_LABEL[value] }));

export function telHref(phone: string): string {
  const digits = phone.replace(/[^\d+]/g, "");
  return `tel:${digits.startsWith("+") || digits.startsWith("00") ? digits : `+4${digits.startsWith("0") ? digits : `0${digits}`}`}`;
}

export function websiteHref(site: string): string {
  return /^https?:\/\//i.test(site) ? site : `https://${site}`;
}

export function todayIso(now = new Date()): string {
  const local = new Date(now.getTime() - now.getTimezoneOffset() * 60_000);
  return local.toISOString().slice(0, 10);
}

export function isDue(p: Prospect, today = todayIso()): boolean {
  return p.next_follow_up != null && p.next_follow_up <= today;
}
